module.exports = __webpack_public_path__ + "img/linea.4ff6e67c.svg";